export default function getDialogData (i18n) {
  return {
    common: {
      error: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.common.title'),
        description: i18n.t('dialog.common.desc')
      }
    },
    dashboard: {
      // todo: hongseok: check description
      deleteApply: {
        type: 'confirm',
        iconClass: 'icon--dialog-trash',
        title: i18n.t('dialog.dashboard.deleteApply.title'),
        description: i18n.t('dialog.dashboard.deleteApply.desc')
      },
      editLimited: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        titleClass: 'warning',
        title: i18n.t('dialog.dashboard.editLimited.title'),
        description: i18n.t('dialog.dashboard.editLimited.desc')
      },
      editCancel: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.dashboard.editCancel.title'),
        description: i18n.t('dialog.dashboard.editCancel.desc')
      },
      saveApplies: {
        type: 'confirm',
        iconClass: 'icon--dialog-confirm',
        title: i18n.t('dialog.dashboard.saveApplies.title'),
        description: i18n.t('dialog.dashboard.saveApplies.desc')
      },
      trackingCodeInstalled: {
        type: 'alert',
        iconClass: 'icon--dialog-confirm',
        description: i18n.t('dialog.dashboard.trackingCodeInstalled.desc')
      },
      trackingCodeNotInstalled: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.dashboard.trackingCodeNotInstalled.desc')
      },
      trackingCodeLoginPage: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.dashboard.trackingCodeLoginPage.desc')
      },
      trackingCodeNetworkingError: {
        type: 'alert',
        iconClass: 'icon--dialog-network',
        description: i18n.t('dialog.dashboard.trackingCodeNetworkingError.desc')
      },
      trackingCodeCheckFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.dashboard.trackingCodeCheckFailed.desc')
      },
      spaOnChange: {
        type: 'confirm',
        iconClass: 'icon--dialog-confirm',
        title: i18n.t('dialog.dashboard.spaOnChange.title'),
        description: i18n.t('dialog.dashboard.spaOnChange.desc')
      },
      spaOffChange: {
        type: 'confirm',
        iconClass: 'icon--dialog-confirm',
        title: i18n.t('dialog.dashboard.spaOffChange.title'),
        description: i18n.t('dialog.dashboard.spaOffChange.desc')
      }
    },
    userInfo: {
      myInformationEditSuccess: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.userInfo.myInformationEditSuccess.title'),
        description: i18n.t('dialog.userInfo.myInformationEditSuccess.desc')
      },
      ipBlockItemDelete: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.userInfo.ipBlockItemDelete.desc')
      },
      ipBlockConfirmEdit: {
        type: 'confirm',
        iconClass: 'icon--dialog-confirm',
        title: i18n.t('dialog.userInfo.ipBlockConfirmEdit.title'),
        description: i18n.t('dialog.userInfo.ipBlockConfirmEdit.desc')
      },
      registerCard: {
        type: 'alert',
        iconClass: 'icon--dialog-card',
        title: i18n.t('dialog.userInfo.registerCard.title'),
        description: i18n.t('dialog.userInfo.registerCard.desc')
      }
    },
    plan: {
      cancelSubscriptionFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.cancelSubscriptionFailed.title'),
        description: i18n.t('dialog.plan.cancelSubscriptionFailed.desc')
      },
      updateFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.updateFailed.title'),
        description: i18n.t('dialog.plan.updateFailed.desc')
      },
      registerCardFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.registerCardFailed.title'),
        description: i18n.t('dialog.plan.registerCardFailed.desc')
      },
      noCurrentPlanFound: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.noCurrentPlanFound.title'),
        description: i18n.t('dialog.plan.noCurrentPlanFound.desc')
      },
      pvEmpty: {
        type: 'pvEmpty',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.pvEmpty.title'),
        description: i18n.t('dialog.plan.pvEmpty.desc')
      },
      completed: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.completed.title'),
        description: i18n.t('dialog.plan.completed.desc')
      },
      pvCompleted: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.pvCompleted.title'),
        description: i18n.t('dialog.plan.pvCompleted.desc')
      },
      applicationCompleted: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.applicationCompleted.title'),
        description: i18n.t('dialog.plan.applicationCompleted.desc')
      }
    },
    abReport: {
      pageList: {
        notExistingAvailableTraffic: {
          type: 'alert',
          iconClass: 'icon--dialog-warning',
          description: i18n.t('dialog.abReport.pageList.notExistingAvailableTraffic.desc')
        }
      }
    },
    page: {
      customTracking: {
        type: 'alert',
        iconClass: 'icon--pause',
        title: i18n.t('dialog.page.customTracking.title'),
        description: i18n.t('dialog.page.customTracking.desc')
      }
    },
    report: {
      reportRequest: {
        success: {
          type: 'mine',
          iconClass: 'icon--check-green-size50',
          title: i18n.t('dialog.report.reportRequested.title'),
          description: i18n.t('dialog.report.reportRequested.description')
        },
        duplicate: {
          type: 'mine',
          iconClass: 'icon--dialog-confirm',
          title: i18n.t('dialog.report.duplicate.title'),
          description: i18n.t('dialog.report.duplicate.description')
        },
        sysError: {
          type: 'alert',
          iconClass: 'icon--dialog-warning',
          title: i18n.t('dialog.report.sysError.title'),
          description: i18n.t('dialog.report.sysError.description')
        }
      },
      invalidRequest: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.report.invalidRequest.title'),
        description: i18n.t('dialog.report.invalidRequest.desc')
      },
      changePeriodResetUtm: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.campaignTargeting.changePeriodResetUtm.title'),
        description: i18n.t('dialog.campaignTargeting.changePeriodResetUtm.desc')
      },
      tokenLimit: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.report.tokenLimit.title'),
        description: i18n.t('dialog.report.tokenLimit.description')
      }
    },
    realtime: {
      type: 'confirm',
      iconClass: 'icon--dialog-warning',
      title: i18n.t('heatmap.realtime.turnOff.title'),
      description: i18n.t('heatmap.realtime.turnOff.desc')
    },
    timezone: {
      timezoneChange: {
        type: 'confirm',
        iconClass: 'icon--modification',
        title: i18n.t('timezone.timezoneChange.title'),
        description: i18n.t('timezone.timezoneChange.desc')
      }
    }
  }
}
